
import React from 'react';
import { cn } from '@/lib/utils';
import { useSidebar } from './context';

export interface SidebarGroupLabelProps extends React.HTMLAttributes<HTMLDivElement> {}

export const SidebarGroupLabel = React.forwardRef<HTMLDivElement, SidebarGroupLabelProps>(
  ({ className, children, ...props }, ref) => {
    const { collapsed } = useSidebar();
    if (collapsed) return null; // Don't render label if collapsed

    return (
      <div
        ref={ref}
        className={cn(
          'px-4 py-2 text-xs font-semibold uppercase text-muted-foreground tracking-wider',
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);
SidebarGroupLabel.displayName = 'SidebarGroupLabel';
